<template>
  <div>
    <Scene5/>
    <Scene6/>
    <Scene7/>
    <Scene8/>
    <Scene9/>
  </div>
</template>

<script>
import { Sprite, Container } from 'pixi.js'
import ChapterMixin from '@/mixins/Chapter'
import Scene5 from './scenes/Scene5'
import Scene6 from './scenes/Scene6'
import Scene7 from './scenes/Scene7'
import Scene8 from './scenes/Scene8'
import Scene9 from './scenes/Scene9'

export default {
    name: 'HouseOfCommons',
    mixins: [ ChapterMixin ],
    components: { Scene5, Scene6, Scene7, Scene8, Scene9 }, 
}
</script>
